module.exports = __webpack_public_path__ + "static/events-catering-ffbeb00ffc6330b552321a1417976d79.jpg";